// SN108/ACK01 - Line Item Status Code, used by the 856's SN1 segment and the
// 855's ACK segment to say whether an item shipped, was accepted, rejected,
// substituted, backordered, deleted or put on hold. The full DE 668 union.

import type {CodeListEntry} from './types';

export const LINE_ITEM_STATUS_CODES: CodeListEntry[] = [
  {code: 'IA', label: 'Item Accepted'},
  {code: 'AC', label: 'Item Accepted and Shipped'},
  {code: 'AR', label: 'Item Accepted and Released for Shipment'},
  {
    code: 'AA',
    label: 'Item Accepted - Order Forwarded to Alternate Supplier Location',
  },
  {code: 'BP', label: 'Item Accepted - Partial Shipment, Balance Backordered'},
  {code: 'DR', label: 'Item Accepted - Date Rescheduled'},
  {code: 'IB', label: 'Item Backordered'},
  {code: 'IC', label: 'Item Accepted - Changes Made'},
  {code: 'ID', label: 'Item Deleted'},
  {code: 'IE', label: 'Item Accepted, Price Pending'},
  {code: 'IF', label: 'Item on Hold, Incomplete Description'},
  {code: 'IH', label: 'Item on Hold'},
  {code: 'IP', label: 'Item Accepted - Price Changed'},
  {code: 'IQ', label: 'Item Accepted - Quantity Changed'},
  {code: 'IR', label: 'Item Rejected'},
  {code: 'IS', label: 'Item Accepted - Substitution Made'},
  {code: 'IW', label: 'Item on Hold-Waiver Required'},
  {code: 'R1', label: 'Item Rejected, Not a Contract Item'},
  {code: 'R2', label: 'Item Rejected, Invalid Item Product Number'},
  {code: 'R3', label: 'Item Rejected, Invalid Unit of Issue'},
  {code: 'R4', label: 'Item Rejected, Contract Item not Available'},
  {code: 'SP', label: 'Item Accepted - Schedule Date Pending'},
];
